import React from 'react'
import { faPrint } from '@fortawesome/pro-light-svg-icons'

import './BackupWallet.css'
import QbHeading from '../shared/QbHeading/QbHeading'
import QbQrCode from '../shared/QbQrCode/QbQrCode'
import QbDisplay from '../shared/QbDisplay/QbDisplay'
import QbButton from '../shared/QbButton/QbButton'
import { mergeToNewObject } from '../../util/helpers'
import WebMenuHolder from '../shared/WebMenu/WebMenuHolder'

const BackupWallet = ({
  t,
  mnemonic,
  copyMnemonic,
  printMnemonic,
  copySuccessMsg,
  walletCreated,
  navigateToReceive,
}) => (
  <div className="main-content-container backup-wallet-container">
    <WebMenuHolder title={t('wallet.backup-title')} />
    <div className="main-content-body">
      <QbHeading title={t('wallet.backup.headline')} text={t('wallet.backup.message')} />
      <div className="backup-wallet-content">
        <QbQrCode
          value={mnemonic}
          size={154}
          className="backup-wallet-qrcode"
        />
        <div className="backup-wallet-display">
          <QbDisplay
            value={mnemonic}
            contentStyle={mergeToNewObject(BACKUP_STYES.DISPLAY_CONTENT, copySuccessMsg ? {borderColor: 'var(--qb-primary-color-one)'} : {})}
          />
          <span className="qb-input-success-msg">{t(copySuccessMsg)}</span>
        </div>
        

        <div className="backup-wallet-instructions">
          <Instruction text={t('wallet.backup.instruction-1')} />
          <Instruction text={t('wallet.backup.instruction-2')} />
          <Instruction text={t('wallet.backup.instruction-3')} />
        </div>

        <QbButton icon={faPrint} name="Print backup phrase" simple className="backup-wallet-button-print" onClick={printMnemonic} />
        {
          walletCreated ?
          <QbButton name="Continue" className="backup-wallet-button-copy" onClick={navigateToReceive} /> :
          <QbButton name="Copy phrase" className="backup-wallet-button-copy" onClick={copyMnemonic} />
        }
        
      </div>
    </div>
  </div>
)

export default BackupWallet

const Instruction = ({ 
  text
}) => (
  <span className="backup-wallet-instruction" > {text} </span>
)

const BACKUP_STYES = {  
  DISPLAY_CONTENT: {
    height: 'auto',
    fontWeight: 600
  }
}



// WEBPACK FOOTER //
// ./src/components/BackupWallet/BackupWallet.js